import type { Error } from '../types';

// TODO: rework
export const maxNumber =
  (max: number, message?: Error['message'], allowEmpty = false, allowDecimals = false) =>
  (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any
  ): Error => {
    const lowerThanMax = allowDecimals ? parseFloat(value) <= max : parseInt(value, 10) <= max;
    const valid = (!!value || value === 0) && lowerThanMax;

    return {
      valid: allowEmpty ? isNaN(value) || valid : valid,
      message
    };
  };
